import React from 'react';
import { Box, Container, Grid, Typography, Link, useTheme, useMediaQuery } from '@mui/material';

const CurrentYear = new Date().getFullYear();

const FooterBottom = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Box className="footer-bottom" sx={{ borderTop: 1, borderColor: 'rgba(255, 255, 255, 0.08)', p: 3 }}>
            <Container maxWidth="lg">
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Typography color="white">
                            BeadsForEducation © {CurrentYear} | All Rights Reserved
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} display="flex" justifyContent={isMobile ? "flex-start" : "center"} gap={2}>
                        <Typography color="white">
                            Developed by{" "}
                            <Link
                                sx={{ textDecoration: 'none', color: '#333f4d' }}
                                href="https://otien0.vercel.app"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Otien0
                            </Link>
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default FooterBottom;
